import { useEffect, useState } from 'react';
import './style.scss';
import Pagination from '../../Pagination';
import { observer, useLocalObservable } from 'mobx-react';
import FooterEventModel from 'common-modules/general/Common/Logic/Event/EventCommon';
import { toJS } from 'mobx';
import { APIClientBaseURL } from 'common-modules/general/Config/constants';
import { cdBizLnd } from 'data/configs';
import NoResultWithLabel from 'common-modules/general/Common/Components/NoResultWithLabel';
import { isAfter, isBefore } from 'common-modules/general/Modules/functions';
import { RoutesString } from 'common-modules/general/Config/routesString';
import { useHistory } from 'react-router';
import replaceImg from 'assets/Desktop/images/common/img_myhome_show.jpg';
import moment from 'moment';

const Event = observer(() => {
  const [type, setType] = useState('1');
  const history = useHistory();

  const [currentPage, setCurrentPage] = useState(1);

  const { model: eventModel } = useLocalObservable(() => ({ model: new FooterEventModel() }));

  useEffect(() => {
    eventModel.getEventListData({ state: type, cdBizLnd: cdBizLnd });
  }, [type, eventModel]);

  const handlePageMove = (sral: string) => {
    history.push(`${RoutesString.SalesEventDetail}/?id=${sral}`);
  };

  const renderProcess = (startDate, endDate) => {
    if (isAfter(startDate)) {
      return '예정';
    } else if (isBefore(endDate)) {
      return '진행중';
    } else {
      return '종료';
    }
  };

  const renderProcessTag = endDate => {
    const flag = isBefore(endDate);

    if (flag) {
      return 'ing';
    } else {
      return 'intend';
    }
  };

  const isIngEvent = (endDate: string): boolean => {
    const flag = isBefore(endDate);

    if (flag) {
      return false;
    } else {
      return true;
    }
  };

  const eventList = toJS(eventModel.eventList.data?.list);
  const totalCount = eventModel.eventList.data?.totalPage || 0;

  return (
    <div className="contents-event">
      <div className="content" id="content">
        <div className="content-container">
          <>
            <div className="container mt-120">
              <div className="content-title">
                <h3 className="content-title-txt">
                  <span className="tit">이벤트</span>
                </h3>

                <div className="sub-tab">
                  <button className={`tab ${type === '1' ? 'on' : ''}`} onClick={() => setType('1')}>
                    <span className="txt">전체</span>
                  </button>
                  <button className={`tab ${type === '2' ? 'on' : ''}`} onClick={() => setType('2')}>
                    <span className="txt">진행중</span>
                  </button>
                  <button className={`tab ${type === '3' ? 'on' : ''}`} onClick={() => setType('3')}>
                    <span className="txt">종료</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="container mt-40 mb-60">
              <ul className="list-content">
                {eventList &&
                  eventList.map((item, index) => (
                    <li className={`item ${isIngEvent(item.dtEnd) && 'event-end'}`}>
                      <div
                        onClick={() => {
                          handlePageMove(item.noEvntSral);
                        }}
                        key={index}>
                        <div className="pc-event01-content-img">
                          {item.noThumSral ? (
                            <img src={`${APIClientBaseURL.file}${item.noThumSral}`} alt="img" />
                          ) : (
                            <img src={replaceImg} alt="img" />
                          )}

                          <span className="dimmed-area"></span>
                        </div>

                        <div className="txt-area">
                          <span className="txt">{item.dsEvnt ? item.dsEvnt : ''}</span>
                          <span className="tit">{item.sbjtNtcPlte}</span>
                          <span className="date">
                            {moment(item.dtBegn, 'YYYY.MM.DD').format('YYYY.MM.DD')} ~{' '}
                            {moment(item.dtEnd, 'YYYY.MM.DD').format('YYYY.MM.DD')}
                          </span>
                          <span className={`process ${renderProcessTag(item.dtEnd)} `}>
                            {renderProcess(item.dtBegn, item.dtEnd)}
                          </span>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
              {(eventList?.length === 0 || !eventList) && <NoResultWithLabel>이벤트가 존재하지 않습니다.</NoResultWithLabel>}
            </div>

            <Pagination limit={10} currentPage={currentPage} setCurrentPage={setCurrentPage} totalCount={totalCount * 10} />
          </>
        </div>
      </div>
    </div>
  );
});

export default Event;
